import {connect} from "react-redux";
import {Button} from "primereact/button";
import React, {useRef, useState} from "react";
import {Toast} from "primereact/toast";
import agent from "../../agent";
import {LOGOUT} from "../../constants/actionTypes";
import PasswordInput from "../Core/PasswordInput/PasswordInput";
import styles from "./UserSettings.module.css";

const mapStateToProps = state => ({
    ...state.common
})
const mapDispatchToProps = dispatch => ({
    onClickLogout: () => dispatch({ type: LOGOUT }),
})

const UserSettings = props => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const showMessage = (severity, summary, detail) => {
        toast.current.show({severity: severity, summary: summary, detail: detail, sticky: true });
    }

    const sendPasswordChangeForm = (e) => {
        e.preventDefault();
        setLoading(true);
        agent.Auth.changePassword({oldPassword, newPassword, repeatPassword}).then(response => {
            response ?
                showMessage('error', 'Ошибка', response.error) :
                (showMessage('success', 'Запрос выполнен', 'Пароль изменен'),
                setTimeout(() => props.onClickLogout(), 2000));
        }).finally(() => setLoading(false))
    }

    return(
        <div className={styles.page}>
            <Toast ref={toast}/>
            <div className={styles.glowOne} />
            <div className={styles.glowTwo} />

            <section className={styles.card}>
                <div className={styles.header}>
                    <h2>Сменить пароль</h2>
                    <p className={styles.subtitle}>
                        После успешного изменения пароля вы автоматически выйдете из системы.
                    </p>
                </div>

                <form onSubmit={sendPasswordChangeForm} className={styles.form}>
                    <div className={styles.field}>
                        <label htmlFor="oldPassword">Старый пароль</label>
                        <PasswordInput
                            id="oldPassword"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            autoComplete="current-password"
                        />
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="newPassword">Новый пароль</label>
                        <PasswordInput
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            autoComplete="new-password"
                        />
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="repeatPassword">Повторите пароль</label>
                        <PasswordInput
                            id="repeatPassword"
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)}
                            autoComplete="new-password"
                        />
                    </div>

                    <Button type="submit" loading={loading} className={styles.submitButton}>
                        Сохранить
                    </Button>
                </form>
            </section>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);
